import { getShiftDurationAsMinutes } from './getShiftDurationAsMinutes'

export const getBreakDurationFromPercentage = (
  shiftTimeRange: [string, string],
  percent: number
) => {
  const [start, end] = shiftTimeRange
  const shiftDurationInMin = getShiftDurationAsMinutes(start, end)
  const breakDurationInMin = (shiftDurationInMin * percent) / 100

  return Math.ceil(breakDurationInMin)
}
